/**
 * Desc:
 * Created Date: Tuesday, September 10th 2024, 6:39:46 pm
 * Author: jim Li
 * -----
 * Last Modified: Tue May 13 2025
 * Modified By: jim Li
 */

export default {
  Tag_Common: {
    Shi: 'Yes',
    Fou: 'No',
    QiYon: 'Enabled',
    TingYon: 'Disabled',
    Fu: 'Mul',
    Dan: 'Sig',
    Nong: 'Ratio',
    DaiRu: 'Bring',
    Tian: 'Day',
    XiaoShi: 'H',
    FenZhong: 'M',
    FenZhong_10: '10 mins',
    FenZhong_15: '15 mins',
    FenZhong_20: '20 mins',
    FenZhong_30: '30 mins',
    FenZhong_60: '1 hr',
    XuanZe: 'Select',
    Yi: 'Mon.',
    Er: 'Tue.',
    San: 'Wed.',
    Si: 'Thu.',
    Wu: 'Fri.',
    Liu: 'Sat.',
    Ri: 'Sun.',
    You: 'Has',
    Wu_Y: 'None',
    Zhou_Yi: 'Mon.',
    Zhou_Er: 'Tue.',
    Zhou_San: 'Wed.',
    Zhou_Si: 'Thu.',
    Zhou_Wu: 'Fri.',
    Zhou_Liu: 'Sat.',
    Zhou_Ri: 'Sun.',
    AR: 'AR',
    BC: 'BC',
    CD: 'CD',
    DI: 'DI',
    EC: 'EC',
    ED: 'ED',
    ID: 'ID',
    MD: 'MD',
    OC: 'OC',
    OP: 'OP',
    OW: 'OW',
    RE: 'RE',
    RP: 'RP',
    TW: 'TW',
    You_Zhi: 'From',
    Zhi_You: 'To',
    GongKai: 'Public',
    Fei_GongKai: 'Non‑public',
    GongYong: 'Common',
    QuanLiang_PanDian: 'All',
    BuFen_PanDian: 'Partial',
    Fan: 'Reverse',
    Wei: 'Fear',
    Tong_DianHua: 'Same Phone',
    Tong_Ming: 'Same Name',
    Tong_ZhengJian: 'Same ID',
  },
}
